/**
 * Permission codes the Wallet Analytics screen declares an interest in
 * (`server/internal/treasury/report_handler.go`).
 *
 *  - `treasury.wallet.read` — five of the six reports and the route itself. The
 *    reports are row-scoped server-side: a custodian sees only their own floats.
 *  - `treasury.wallet.funding.read` — loads in transit. The tab is offered only
 *    to a holder, exactly as the server refuses everyone else.
 *  - Drill targets have their own doors: a count sheet needs `treasury.wallet.count`,
 *    a transfer instruction `cash.transfer.read`. Without them the reference is text.
 */
export const WALLET_ANALYTICS_PERMISSIONS = {
  read: 'treasury.wallet.read',
  fundingRead: 'treasury.wallet.funding.read',
  countRead: 'treasury.wallet.count',
  transferRead: 'cash.transfer.read',
} as const
